import { render, staticRenderFns } from "./LpuCardRating.vue?vue&type=template&id=4faf05fc&"
import script from "./LpuCardRating.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardRating.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faf05fc')) {
      api.createRecord('4faf05fc', component.options)
    } else {
      api.reload('4faf05fc', component.options)
    }
    module.hot.accept("./LpuCardRating.vue?vue&type=template&id=4faf05fc&", function () {
      api.rerender('4faf05fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCardRating.vue"
export default component.exports